function SentinelUiFilterService($rootScope) {

    var callbacks = {},
        displayOptionsProto = {
            showComments: false,
            showActiveOnly: false,
            showCards: false,
            summaryReport: false,
            filterByFacility: '',
            sortField: 'checkInTime',
            sortDirection: 'desc'
        },
        fieldNames = {
            DURATION: 'duration',
            DOOR_IN: 'doorIn',
            DOOR_OUT: 'doorOut',
            ESCORT_IN: 'escortIn',
            ESCORT_OUT: 'escortOut',
            FACILITY_NAME: 'facilityName',
            BADGE_CODE_MANUAL: 'badgeCodeManual',
            REGISTRATION_TIME: 'timeRegistered',
            CHECK_IN_TIME: 'checkInTime',
            CHECK_OUT_TIME: 'checkOutTime',
            VISITING: 'visiting',
            REASON: 'reason',
            COMPANY: 'company',
            TELEPHONE: "telephone",
            IS_CITIZEN: "isCitizen",
            NDA: "nda",
            FORMATTED_NAME: 'formattedName'
        },
        masterDisplayOptions = $.extend(true, {}, displayOptionsProto),
        sortDirection = {
            ASC: 'asc',
            DESC: 'desc'
        },
        tables = {};

    this.filterRegisteredGuests = function (visits) {
        return visits.filter(function (item) {
            return !item.checkInTime && !item.checkOutTime;
        });
    };

    this.filterActiveOnly = function (visits) {
        return visits.filter(function (item) {
            return item.checkInTime && !item.checkOutTime;
        });
    };

    this.getMasterDisplayOptions = function () {
        return masterDisplayOptions
    };

    this.setMasterDisplayOptions = function (displayOptions) {
        masterDisplayOptions = displayOptions;
    };

    this.getTableDisplayOptions = function (tableName) {
        if (!tables[tableName]) {
            tables[tableName] = $.extend(true, {}, displayOptionsProto);
        }
        return tables[tableName];
    };

    this.setTableDisplayOptions = function (tableName, options) {
        tables[tableName] = options;
    };

    this.transformVisitsBySite = function (visits) {
        var sites = [];
        for (var i = 0; i < visits.length; i++) {
            var siteVisit = visits[i];
            var found = false;

            for (var j = 0; j < sites.length; j++) {
                var site = sites[j];
                if (site.facilityName === siteVisit.facilityName) {
                    site.visits.push(siteVisit);

                    found = true;
                    break;
                }
            }

            if (!found) {
                sites.push({
                    facilityName: siteVisit.facilityName,
                    visits: [siteVisit]
                });
            }
        }
        return sites;
    };

    this.sortSites = function (sortBy, sites) {
        if (sortBy !== fieldNames.FACILITY_NAME) {
            sortBy = fieldNames.FACILITY_NAME;
            console.warn("Invalid sort option provided. Defaulting to sort by facilityName.");
        }

        return sites.sort(function (a, b) {
            if (a[sortBy] === b[sortBy]) {
                return 0;
            }

            return (a[sortBy] < b[sortBy]) ? -1 : 1
        });
    };

    this.sortVisits = function (sortBy, direction, visits) {
        var fieldValid = false,
            directionValid = false;

        for(var fieldName in fieldNames){
            if(fieldNames[fieldName] === sortBy) {
                fieldValid = true;
                break;
            }
        }

        if(!fieldValid){
            sortBy = fieldNames.CHECK_IN_TIME;
            console.warn("Invalid sort option provided. Defaulting to sort by check in time.");
        }

        for(var directionName in sortDirection){
            if(sortDirection[directionName] === direction) {
                directionValid = true;
                break;
            }
        }

        if(!directionValid){
            direction = sortDirection.DESC;
            console.warn("Invalid sort direction provided. Defaulting to sort descending.");
        }

        return visits.sort(function (a, b) {
            var aSort,
                bSort;

            if (sortBy === fieldNames.REGISTRATION_TIME || sortBy === fieldNames.CHECK_IN_TIME || sortBy === fieldNames.CHECK_OUT_TIME) {
                aSort = a[sortBy] ? new Date(a[sortBy]) : new Date(2999, 12, 31, 23, 59, 59, 999);
                bSort = b[sortBy] ? new Date(b[sortBy]) : new Date(2999, 12, 31, 23, 59, 59, 999);
            } else if (sortBy === fieldNames.DURATION) {
                aSort = a[sortBy];
                bSort = b[sortBy];
            } else {
                aSort = a[sortBy] ? a[sortBy].toString().trim().toUpperCase() : '';
                bSort = b[sortBy] ? b[sortBy].toString().trim().toUpperCase() : '';
            }

            if (aSort === bSort) { return 0; }

            if(direction === sortDirection.DESC) {
                return (aSort > bSort) ? -1 : 1;
            } else {
                return (aSort < bSort) ? -1 : 1;
            }
        });
    };

}

angular.module("sentinel").service("sentinelUiFilterService", ['$rootScope', SentinelUiFilterService]);